"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0,
};
var ScrollLoader = function (_a) {
    var load = _a.load, _b = _a.component, Component = _b === void 0 ? 'div' : _b;
    var ref = (0, react_1.useRef)(null), _c = __read((0, react_1.useState)(false), 2), triggerLoad = _c[0], setTriggerLoad = _c[1], handleObserver = (0, react_1.useCallback)(function (entries) {
        if (entries[0].intersectionRatio <= 0) {
            return;
        }
        setTriggerLoad(true);
    }, []), observer = (0, react_1.useMemo)(function () {
        return new IntersectionObserver(handleObserver, observerOptions);
    }, [handleObserver]);
    (0, react_1.useEffect)(function () {
        if (!triggerLoad) {
            return;
        }
        load();
        setTriggerLoad(false);
    }, [triggerLoad, load]);
    (0, react_1.useEffect)(function () {
        var observableRef = ref.current;
        if (!observer || !observableRef || observer.root) {
            return;
        }
        observer.observe(observableRef);
        return function () {
            if (!observableRef)
                return;
            observer.unobserve(observableRef);
        };
    }, [observer]);
    return react_1.default.createElement(Component, { ref: ref, "data-testid": "scroll-loader" });
};
exports.default = ScrollLoader;
//# sourceMappingURL=index.js.map